import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { PageDto } from './../shared/page.dto';
import { PageQueriesModel } from './../shared/page-queries.model';

import { ClientDto } from './client.dto';

@Injectable()
export class ClientRestService {
  constructor(private http: HttpClient) {}

  private apiUrl = 'api/accountManagement/clients';

  list(queries: PageQueriesModel) {
    const url = this.apiUrl;
    const options = {
      params: queries.getParams()
    };

    return this.http.get<PageDto<ClientDto>>(url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new ClientDto(i));
        return page;
      })
    );
  }

  post(d: ClientDto) {
    const url = this.apiUrl;
    return this.http
      .post<ClientDto>(url, d)
      .pipe(map(data => new ClientDto(data)));
  }

  put(d: ClientDto) {
    const url = `${this.apiUrl}/${d.identity.id}`;
    return this.http
      .put<ClientDto>(url, d)
      .pipe(map(data => new ClientDto(data)));
  }

  get(clientId: string) {
    const url = `${this.apiUrl}/${clientId}`;

    return this.http.get<ClientDto>(url).pipe(map(d => new ClientDto(d)));
  }

  patch(d: ClientDto, clientId: string) {
    const url = `${this.apiUrl}/${clientId}`;
    return this.http
      .patch<ClientDto>(url, d)
      .pipe(map(data => new ClientDto(data)));
  }
}
